export default function contentUnload() {
	return (dispatch) => {
		dispatch({
			type: 'CONTENT_UNLOAD',
		});
	};
}